import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const Content = () => {
    return (
        <div className={styles.head}>
            <div className={styles.icon} />
            <p>凤凰新闻感谢您的多年相伴</p>
            <div className={styles.icon} />
        </div>
    );
};

Content.propTypes = {};

export default errorBoundary(Content);
